import { render, staticRenderFns } from "./ProxyAddDialog.vue?vue&type=template&id=1b4f854a"
import script from "./ProxyAddDialog.vue?vue&type=script&lang=js"
export * from "./ProxyAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports